import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IRequestCallback } from '@df/api/request/request.service';
import { CouponFormComponentDef } from '@df/basket/coupon-form.component.def';
import { MuiInputDirective } from '@df/legacy/ui/form/mui-input.directive';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ActionComponent } from '../ui/api/action.component';
import { InputWrapBodyDirective } from '../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../ui/form/input-wrap.component';
import { ResultComponent } from '../ui/resut/result.component';
import { BasketAddPromoGiftService } from './add-promo-gift/basket-add-promo-gift.service';
export interface ICouponFormData {
    coupon: string | string[];
    checkout?: boolean;
}
@Component({
    selector: 'coupon-form',
    standalone: true,
    imports: [
        FormsModule,
        ZippyModule,
        TranslationModule,
        InputWrapComponent,
        InputWrapBodyDirective,
        MuiInputDirective,
        ActionComponent,
        ResultComponent
    ],
    templateUrl: './coupon-form.html'
})
export class CouponFormComponent extends CouponFormComponentDef {
    private basketAddPromoGiftService = inject(BasketAddPromoGiftService);

    protected errorOverride: string | undefined;

    override ngOnInit() {
        super.ngOnInit();
        this.subscriptions.add(
            this.status.subscribe(() => {
                setTimeout(() => {
                    this.errorOverride = this.status.errorData?.details;
                    this.detectChanges();
                }, 0); // we need to delay cause errorData is not available immediately
            })
        );
    }
    override submit(onSuccess?: IRequestCallback, onError?: IRequestCallback): void {
        super.submit(async data => {
            if (data?.amastyPromoGiftProducts) {
                await this.basketAddPromoGiftService.getPromoProduct(data.amastyPromoGiftProducts);
            }
        }, onError);
    }
}
